import { Switch } from '@mui/material';
import { MenuDropdownItem } from 'components/MenuDropdown/MenuDropdownItem';
import { SyntheticEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import { GAEvents } from 'services/tracking/GAEvents';
import gtmIds from 'services/tracking/GTMIds';
import { useAppThemeStore, useIsDarkMode } from 'styles/new-theme/useAppThemeStore';

export const DarkModeToggleItem = () => {
  const isDarkMode = useIsDarkMode();
  const setThemeMode = useAppThemeStore(state => state.setThemeMode);

  const handleToggle = (event: SyntheticEvent) => {
    event.preventDefault();

    const newThemeMode = isDarkMode ? 'light' : 'dark';
    setThemeMode(newThemeMode);

    // Update body class name
    if (newThemeMode === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }

    if (newThemeMode === 'dark') {
      GAEvents.darkModeEnabled();
    } else {
      GAEvents.darkModeDisabled();
    }
  };

  return (
    <MenuDropdownItem
      gtmId={gtmIds.sidebar.accountMenuItem}
      icon={<Switch size="small" checked={isDarkMode} onChange={handleToggle} />}
      onClick={handleToggle}
      testAttribute="sidebar-dark-mode-toggle-item"
    >
      <FormattedMessage id="layout.sidebar.actions.profile.dark_mode" />
    </MenuDropdownItem>
  );
};
